import {
  Field,
  Text,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import React from "react";
import { TYPOGRAPHY_LINK1_CAPS } from "@/typography-constants";
import classes from "./text-content.module.css";

export type AnimatedCtaProps = {
  textColour: Field<string>;
  ctaText: Field<string>;
  isHero: boolean;
  mobileView?: boolean;
};

const AnimatedCta = (props: AnimatedCtaProps) => {
  const { textColour, ctaText, mobileView, isHero } = props;
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!isEditing && !ctaText.value) {
    return <></>;
  }

  return (
    <p
      data-testid="animated-cta"
      style={{ color: textColour.value || undefined }}
      className={clsx(
        TYPOGRAPHY_LINK1_CAPS,
        classes[!mobileView && isHero ? "desktopHeroCtaLink" : "ctaLink"],
      )}
    >
      <Text field={ctaText} tag="span" />
      <span
        className={classes.ctaUnderline}
        style={{
          backgroundColor: textColour.value || "var(--secondary-500)",
        }}
      />
    </p>
  );
};

export default AnimatedCta;
